import React, {useState, useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import NewsList from '../../common/NewsList'
import AddCircleIcon from "@mui/icons-material/AddCircle";
import theme_positive from '../../../assets/images/theme_positive.png'
import theme_negative from '../../../assets/images/theme_negative.png'
import CardHorizontalWithLargeThumbnail from '../../common/cardNews/CardHorizontalWithLargeThumbnail';
import SummaryCardLayout from "./SummaryCardLayout";
import {getHomeDataAPI} from "../../../apis/news_service";
import {getMyDataAPI} from "../../../apis/my_service";
import Loading from "../../../pages/error/Loading";
import more from '../../../assets/images/ico_more.svg'


const ThemeNewsLayout = () => {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(true);

    const [orderType, setOrderType] = useState('NEWS') // 긍정뉴스 조회기준 NEWS or CHANGE
    const [orderType_n, setOrderType_n] = useState('NEWS') // 부정뉴스 조회기준 NEWS or CHANGE
    const [tSummarymsg,setTSummarymsg] = useState('') // 오늘의 큐레이팅
    const [mSummarymsg,setMSummarymsg] = useState('') // 3개월 통계 큐레이팅
    const [newsList, setNewsList] = useState([]); // 뉴스 리스트
    const [themeList, setThemeList] = useState([]); // 종목 리스트
    const [tSummarymsg_n,setTSummarymsg_n] = useState('') // 오늘의 큐레이팅
    const [mSummarymsg_n,setMSummarymsg_n] = useState('') // 3개월 통계 큐레이팅
    const [newsList_n, setNewsList_n] = useState([]); // 뉴스 리스트
    const [themeList_n, setThemeList_n] = useState([]); // 종목 리스트

    const moreBtnClick = () =>{navigate('/theme')} // 디테일 페이지 이동
    // const moveToNews = (id, name, signal) => {navigate(`/news/${id}`, {state: {stockname: name, signal: signal}})}
    const moveToNews = (type,signal,title, range) => {navigate(`/news/${type}/${signal === '긍정' ? "positive" : 'negative'}`, {state: {type:type,title:title,range: range}})}

    const themeHomeData = () => {
        getHomeDataAPI('theme','1', orderType, 4).then(res => {
            setTSummarymsg(res.tSummarymsg)
            setMSummarymsg(res.mSummarymsg)
            setNewsList(res.newslist)
            setThemeList(res.themelist.slice(-5))
            setLoading(false)
        })
        getHomeDataAPI('theme','2', orderType_n, 4).then(res => {
            setTSummarymsg_n(res.tSummarymsg)
            setMSummarymsg_n(res.mSummarymsg)
            setNewsList_n(res.newslist)
            setThemeList_n(res.themelist.slice(-5))
            setLoading(false)
        })
    }

    const themeMyData = () => {
        getMyDataAPI('theme','1', orderType, 4).then(res => {
            setTSummarymsg(res.tSummarymsg)
            setMSummarymsg(res.mSummarymsg)
            setNewsList(res.newslist)
            setThemeList(res.themelist.slice(-5))
            setLoading(false)
        })
        getMyDataAPI('theme','2', orderType_n, 4).then(res => {
            setTSummarymsg_n(res.tSummarymsg)
            setMSummarymsg_n(res.mSummarymsg)
            setNewsList_n(res.newslist)
            setThemeList_n(res.themelist.slice(-5))
            setLoading(false)
        })
    }

    useEffect(()=>{
        if(window.location.pathname.includes('mycorp')){
            themeMyData()
        }else {
            themeHomeData()
        }
    },[orderType, orderType_n])

    return (
        <>
            <div className='theme inner_container'>
                <div className='divider' >
                    <span className='title_lg'>테마 뉴스</span>
                    <div className='plus_icon'>
                        <span className='more' >더보기</span>
                        <AddCircleIcon sx={{width:'32px', height:'32px',}} onClick={moreBtnClick}/>
                    </div>
                </div>
                {loading ? <Loading/>
                    :
                    <>
                        <div className='main_layout'>
                            <div className='positive_area'>
                                <div className='flex_layout' style={{margin:'32px 0 20px 0'}}>
                                    <p>
                                        <span onClick={()=>setOrderType('NEWS')} className={`${orderType === 'NEWS'? 'on' : ''}`}>긍정 뉴스가 많은 기업 순</span>
                                        <span className='separator'>·</span>
                                        <span onClick={()=>setOrderType('CHANGE')}  className={`${orderType === 'NEWS'? '' : 'on'}`}>상승률 높은 기업 순</span>
                                    </p>

                                    <div className='click'>
                                        {/*<span  className='click' onClick={()=>moveToNews(newsList[0].stockcode, newsList[0].stockname, '긍정')}>뉴스 더보기</span>*/}
                                        <span  className='click' onClick={()=>moveToNews('theme', '긍정',newsList[0].themaname,  newsList[0].themacode)}>뉴스 더보기</span>
                                        <img src={more} alt='more'/>
                                    </div>
                                </div>
                                <div className='theme_curate_box'>
                                    <img src={theme_positive} alt='theme_img'/>
                                    <p>{tSummarymsg + '\n\n' + mSummarymsg}</p>
                                </div>
                                {newsList && <CardHorizontalWithLargeThumbnail news={newsList[0]}/>}
                                <NewsList newsList={newsList} type='title' size='4' main='main'/>

                            </div>

                            <div className='negative_area'>
                                <div className='flex_layout' style={{margin:'32px 0 20px 0'}}>
                                    <p>
                                        <span onClick={()=>setOrderType_n('NEWS')}  className={`${orderType_n === "NEWS"? 'on' : ''}`}>부정 뉴스가 많은 기업 순</span>
                                        <span className='separator'>·</span>
                                        <span onClick={()=>setOrderType_n('CHANGE')}  className={`${orderType_n === "CHANGE"? 'on' : ''}`}>하락률 높은 기업 순</span>
                                    </p>
                                    <div className='click'>
                                        <span  className='click'  onClick={()=>moveToNews('theme', '부정',newsList_n[0].themaname,  newsList_n[0].themacode)}>뉴스 더보기</span>
                                        <img src={more} alt='more'/>
                                    </div>

                                </div>
                                <div className='theme_curate_box'>
                                    <img src={theme_negative} alt='theme_img'/>
                                    <p>{tSummarymsg_n + '\n\n' + mSummarymsg_n}</p>
                                </div>
                                {newsList_n && <CardHorizontalWithLargeThumbnail news={newsList_n[0]}/>}
                                <NewsList newsList={newsList_n} type='horizontal_with_thumb' size='2' main='main'/>
                            </div>
                        </div>
                    </>
                }

            </div>
            {loading === false && <SummaryCardLayout stockList={themeList} stockList_n={themeList_n} bg='#2b3c62' padding='60px 0 60px 0' type='테마'/>}

        </>

    );
};

export default ThemeNewsLayout;